import { Fragment, useEffect, useState } from "react";
import { Separator } from "../../components/separator";
import FeeAndGst from "./stage-c-fee-cost";
interface StageCFeesProps {
  valuationFee: number;
  totalFee: number | string;
  bypassAdminFee: boolean;
  bypassValuationFee: boolean;
}

export interface FeeBreakdown {
  fee_type?: string;
  fee_cost?: number | string;
  fee_reminder?: string | JSX.Element;
}

const StageCFees = (props: StageCFeesProps) => {

  const [feeBreakdown, setFeeBreakdown] = useState<FeeBreakdown[]>([]);

  useEffect(() => {
    const temp: FeeBreakdown[] = [
      {
        fee_type: "Administrative fee",
        fee_cost: props.bypassAdminFee ? "Waived" : 50.0,
        fee_reminder:
          "There is a fee for the submission of a change in flat ownership application. Administrative fee is inclusive of GST.",
      },
    ];

    const valuationFeeBreak = {
      fee_type: "Valuation fee",
      fee_cost: props.bypassValuationFee ? "Waived" : props.valuationFee,
      fee_reminder: 
      <div className="polymer-fees-400">
          The valuation fee, based on your flat type, is required based on information provided in your application form to,
          <ol>
            <li>Determine mortgage loan ceiling, should proposed owners requires a fresh HDB loan; and/or</li>
            <li>Determine the relevant stamp duty (payable to IRAS) based on applicants' selection of the options in the application form</li>
          </ol>
          Valuation fee is inclusive of administration fee and GST.
      </div>,
    }

    if(props.valuationFee > 50){
      temp.push(valuationFeeBreak);
    }
    setFeeBreakdown([...temp]);
  }, [props.valuationFee]);

  return (
    <div className="polymer-fees-container">
      <div className="polymer-fees-header">
        <p className="polymer-fees-subheader">Fees</p>
      </div>
      <Separator />
      {feeBreakdown.map((item, index) => {
        const key = index;
        return (
          <Fragment key={key}>
            <div key={item.fee_type} className="polymer-fees-text">
              <div className="polymer-fees-gst-container">
                <p className="polymer-fees-700">{`${item.fee_type}:`}</p>
                <FeeAndGst fee_cost={item.fee_cost} />
              </div>
              {typeof item.fee_reminder === "string"? <p className="polymer-fees-400">{item.fee_reminder}</p> : item.fee_reminder}
            </div>
            {index !== feeBreakdown.length - 1 && <Separator />}
          </Fragment>
        );
      })}
      <Separator />
      <div className="polymer-fees-total-container">
        <p className="polymer-fees-700">Total:</p>
        <FeeAndGst fee_cost={props.totalFee} />
      </div>
    </div>
  );
};

export default StageCFees;
